import React, { useRef, useEffect, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { useLocalization } from '@ui-framework/index';
import ArrowTab, { ArrowTabGroup } from './ArrowTab';

function ContentStepper({ header, sectionRefs, children, pageSections = [] }) {
  const { formatMessage } = useLocalization();
  const [activeStep, setActiveStep] = useState(0);
  const theme = useTheme();
  const tabsContainerRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        const visible = entries
          .filter(e => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible.length > 0) {
          setActiveStep(
            pageSections.findIndex(
              item => item.locale.id === visible[0].target.id,
            ),
          );
        }
      },
      {
        rootMargin: '-40% 0px -50% 0px',
        threshold: 0.1,
      },
    );
    pageSections.forEach(({ locale: { id } }) => {
      const el = sectionRefs.current[id];
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [pageSections]);

  const handleStepClick = (locale, newIndex) => {
    const section = sectionRefs.current[locale];
    const stickyHeight = tabsContainerRef.current?.offsetHeight || 48;

    if (section) {
      const top =
        section.getBoundingClientRect().top +
        window.scrollY -
        stickyHeight -
        10;
      window.scrollTo({ top, behavior: 'smooth' });
    }
    setActiveStep(newIndex);
  };

  return (
    <Box>
      <Box
        ref={tabsContainerRef}
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          marginBottom: '10px',
          backgroundColor: theme.palette.background.content,
        }}>
        {header}
        <ArrowTabGroup value={activeStep}>
          {pageSections.map((formItem, formIdx) => (
            <ArrowTab
              key={formItem.locale.id}
              maxTabs={pageSections.length}
              label={formatMessage({
                id: formItem.locale.id,
                defaultMessage: formItem.locale.defaultMessage,
              })}
              value={formIdx}
              onClick={() => handleStepClick(formItem.locale.id, formIdx)}
            />
          ))}
        </ArrowTabGroup>
      </Box>
      <Box>{children}</Box>
    </Box>
  );
}

export default ContentStepper;
